import { Component, OnInit } from '@angular/core';
import { EnvironmentVariablesService } from '@kenv';
import { AuthenticationBloc } from '@kp/auth/authentication.bloc';
import { DataLinkBloc } from '@kp/data-link/data-link.bloc';
import { DataStoreService, TitleService, productDisplayName } from '@kservice';
import { Product } from '@ktypes/enums';
import { AuthData } from '@ktypes/models';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'kp-existing-account',
  templateUrl: './existing-account.component.html',
  styleUrls: ['./existing-account.component.scss'],
})
export class ExistingAccountComponent implements OnInit {
  productName = productDisplayName;
  showMobileScreen: boolean;

  private _title = 'Existing Account';

  constructor(
    private _authenticationBloc: AuthenticationBloc,
    private _deviceDetectorService: DeviceDetectorService,
    private _dataLinkBloc: DataLinkBloc,
    private _dataStoreService: DataStoreService,
    private _envVariablesService: EnvironmentVariablesService,
    private _titleService: TitleService
  ) {}

  ngOnInit(): void {
    this._titleService.set(this._title);
    this._clearPulseSurveyAuthData();
    this.showMobileScreen =
      (this._deviceDetectorService.isMobile() || this._deviceDetectorService.isTablet()) &&
      this._envVariablesService.product === Product.purposeful;
  }

  private _clearPulseSurveyAuthData(): AuthData {
    // clear out any external pulse survey info
    this._dataStoreService.setPulseSurveyAuthData(null);
    this._dataLinkBloc.clearLinkData();
    return this._authenticationBloc.restoreExistingAuthData();
  }
}
